import React, { Fragment, Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import Countries from "./../../components/Countries";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { profileVendor, sellerProfile } from "../../actions/profile";
class StoreInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerDetails: "",
      storeName: "",
      storePhone: "",
      storeLogo: "",
      storeBanner: "",
      storeAddress: "",
      storeCountry: "",
      storeRegion: "",
      storeCity: "",
      storePostcode: "",
      storeShoppingPolicy: "",
      storeReturnPolicy: "",
      storeMetaKeywords: "",
      storeMetaDescription: "",
      storeSlug: "",
      storeFacebook: "",
      storeTwitter: "",
      storeInstagram: "",
      storePinterest: "",
      storeWebsite: "",
      storeWhatsapp: "",
      sellerBankDetail: "",
      taxIdentificationNumber: "",
      paypalEmail: "",
      sellerInfoTab: "show",
      sellerPaymentTab: "hide",
      sellerPaymentTabIcon: "",
      formClass: "show",
      successMessge: "hide",
      storeLogoUrl: "",
      storeBannerUrl: "",
    };
  }
  async componentDidMount() {
    const sellerDetails = await this.props.sellerProfile();

    this.setState({
      sellerDetails: sellerDetails,
      storeName: sellerDetails.storeName,
      storePhone: sellerDetails.storePhone,
      storeLogoUrl: sellerDetails.storeLogo,
      storeBannerUrl: sellerDetails.storeBanner,
      storeAddress: sellerDetails.storeAddress,
      storeCountry: sellerDetails.storeCountry,
      storeRegion: sellerDetails.storeRegion,
      storeCity: sellerDetails.storeCity,
      storePostcode: sellerDetails.storePostcode,
      storeShoppingPolicy: sellerDetails.storeShoppingPolicy,
      storeReturnPolicy: sellerDetails.storeReturnPolicy,
      storeMetaKeywords: sellerDetails.storeMetaKeywords,
      storeMetaDescription: sellerDetails.storeMetaDescription,
      storeSlug: sellerDetails.storeSlug,
      storeFacebook: sellerDetails.storeFacebook,
      storeTwitter: sellerDetails.storeTwitter,
      storeInstagram: sellerDetails.storeInstagram,
      storePinterest: sellerDetails.storePinterest,
      storeWebsite: sellerDetails.storeWebsite,
      storeWhatsapp: sellerDetails.storeWhatsapp,
      sellerBankDetail: sellerDetails.sellerBankDetail,
      taxIdentificationNumber: sellerDetails.taxIdentificationNumber,
      paypalEmail: sellerDetails.paypalEmail,
    });
  }
  _handleImageChangeLogo(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        storeLogo: file,
      });
    };
    reader.readAsDataURL(file);
  }
  _handleImageChangeBanner(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        storeBanner: file,
      });
    };
    reader.readAsDataURL(file);
  }

  profileVendor = async () => {
    if (this.state.storeName !== "") {
      const {
        storeName,
        storePhone,
        storeLogo,
        storeBanner,
        storeAddress,
        storeCountry,
        storeRegion,
        storeCity,
        storePostcode,
        storeShoppingPolicy,
        storeReturnPolicy,
        storeMetaKeywords,
        storeMetaDescription,
        storeSlug,
        storeFacebook,
        storeTwitter,
        storeInstagram,
        storePinterest,
        storeWebsite,
        storeWhatsapp,
        sellerBankDetail,
        taxIdentificationNumber,
        paypalEmail,
      } = this.state;
      let formData = new FormData();
      formData.append("storeName", storeName);
      formData.append("storePhone", storePhone);
      formData.append("storeLogo", storeLogo);
      formData.append("storeBanner", storeBanner);
      formData.append("storeAddress", storeAddress);
      formData.append("storeCountry", storeCountry);
      formData.append("storeRegion", storeRegion);
      formData.append("storeCity", storeCity);
      formData.append("storePostcode", storePostcode);
      formData.append("storeShoppingPolicy", storeShoppingPolicy);
      formData.append("storeReturnPolicy", storeReturnPolicy);
      formData.append("storeMetaKeywords", storeMetaKeywords);
      formData.append("storeMetaDescription", storeMetaDescription);
      formData.append("storeSlug", storeSlug);
      formData.append("storeFacebook", storeFacebook);
      formData.append("storeTwitter", storeTwitter);
      formData.append("storeInstagram", storeInstagram);
      formData.append("storePinterest", storePinterest);
      formData.append("storeWebsite", storeWebsite);
      formData.append("storeWhatsapp", storeWhatsapp);
      formData.append("sellerBankDetail", sellerBankDetail);
      formData.append("taxIdentificationNumber", taxIdentificationNumber);
      formData.append("paypalEmail", paypalEmail);

      const res = await this.props.profileVendor(formData);

      if (res.status === 200) {
        toast(`Request Successfully Updated`, { containerId: "B" });
        this.setState({
          successMessge: "show",
          formClass: "hide",
        });
      }
    } else {
      toast.error(`Please Enter the Store Name`, { containerId: "B" });
    }
  };
  render() {
    const { user } = this.props._auth;
    const { sellerDetails } = this.state;
    return (
      <Fragment>
        <div className="store-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`My Account`} />
          <div className="container-fluid px-0">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <div className="store-wrapper">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12">
                        <header className="store-header">
                          <h2 className="store-title">Store Information</h2>
                        </header>
                        <div className="store-body">
                          <div className="store-method-card">
                            <div className="store-inputs-container">
                              <label
                                htmlFor="sellername"
                                className="store-input-field"
                              >
                                <input
                                  type="hidden"
                                  name="userId"
                                  defaultValue={user && user._id}
                                />
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeName
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeName: e.target.value,
                                      userId: user && user._id,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Seller Name
                                </span>
                              </label>

                              <div className="store-logo my-2">
                                <span className="store-logo-txt">
                                  Store Logo
                                </span>
                                <br />
                                <span>
                                  <img
                                    src={
                                      this.state.storeLogoUrl &&
                                      this.state.storeLogoUrl
                                    }
                                    height="100px"
                                    width="100px"
                                    style={{ borderRadius: "20px" }}
                                    alt=""
                                  />
                                  <br />
                                  <br />
                                  <input
                                    type="file"
                                    onChange={(e) =>
                                      this._handleImageChangeLogo(e)
                                    }
                                  />
                                </span>
                              </div>
                              <label
                                htmlFor="storephone"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storePhone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storePhone: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Store Phone
                                </span>
                              </label>
                              <label
                                htmlFor="fblink"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeFacebook
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeFacebook: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Facebook Link
                                </span>
                              </label>

                              <label
                                htmlFor="twitterlink"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeTwitter
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeTwitter: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Twitter Link
                                </span>
                              </label>
                              <label
                                htmlFor="instalink"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails &&
                                    sellerDetails.storeInstagram
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeInstagram: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Instagram Link
                                </span>
                              </label>
                              <label
                                htmlFor="pinterestlink"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails &&
                                    sellerDetails.storePinterest
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storePinterest: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Pinterest Link
                                </span>
                              </label>
                              <label
                                htmlFor="weblink"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeWebsite
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeWebsite: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Website Link
                                </span>
                              </label>
                              <label
                                htmlFor="whatsappnumber"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeWhatsapp
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeWhatsapp: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Whatsapp Number
                                </span>
                              </label>
                              <div className="store-banner my-2">
                                <span className="store-banner-txt">
                                  Store banner
                                </span>
                                <br />
                                <span>
                                  <img
                                    src={
                                      this.state.storeBannerUrl &&
                                      this.state.storeBannerUrl
                                    }
                                    height="100px"
                                    width="100px"
                                    style={{ borderRadius: "20px" }}
                                    alt=""
                                  />
                                  <br />
                                  <br />
                                  <input
                                    type="file"
                                    onChange={(e) =>
                                      this._handleImageChangeBanner(e)
                                    }
                                  />
                                </span>
                              </div>
                              <hr />
                              <div className="store-address">
                                <div className="store-card-header">
                                  <span>Store Address</span>
                                  <textarea
                                    className="store-textarea"
                                    id="store-address-detail"
                                    cols={75}
                                    rows={2}
                                    defaultValue={
                                      sellerDetails &&
                                      sellerDetails.storeAddress
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        storeAddress: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <hr />
                              <label
                                htmlFor="storecity"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeCity
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeCity: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Store City
                                </span>
                              </label>
                              <div className="checkout-inps">
                                <span className="selectcountry-hint">
                                  Store country
                                </span>
                                <Countries />
                              </div>

                              <label
                                htmlFor="storepostcode"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storeRegion
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storeRegion: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Store Region / State
                                </span>
                              </label>
                              <label
                                htmlFor="storepostcode"
                                className="store-input-field"
                              >
                                <input
                                  type="text"
                                  className="store-input"
                                  defaultValue={
                                    sellerDetails && sellerDetails.storePostcode
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      storePostcode: e.target.value,
                                    })
                                  }
                                />
                                <span className="store-inp-placeholder">
                                  Store Postcode
                                </span>
                              </label>
                              <div className="store-texarea-con">
                                <div className="store-card-header">
                                  <span>Store Meta Keywords</span>
                                  <textarea
                                    className="store-textarea"
                                    id="store-address-detail"
                                    cols={75}
                                    rows={2}
                                    defaultValue={
                                      sellerDetails &&
                                      sellerDetails.storeMetaKeywords
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        storeMetaKeywords: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="store-texarea-con">
                                <div className="store-card-header">
                                  <span>Store Meta Description</span>
                                  <textarea
                                    className="store-textarea"
                                    id="store-address-detail"
                                    cols={75}
                                    rows={2}
                                    defaultValue={
                                      sellerDetails &&
                                      sellerDetails.storeMetaDescription
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        storeMetaDescription: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <div className="submit-store-method">
                                <button className="back-store-btn">
                                  <span>Back</span>
                                </button>
                                <button
                                  className="submit-store-btn"
                                  onClick={this.profileVendor}
                                >
                                  <span>Submit</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  _auth: state.auth,
});
profileVendor.PropTypes = {
  profileVendor: PropTypes.func.isRequired,
};
sellerProfile.PropTypes = {
  sellerProfile: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, { profileVendor, sellerProfile })(StoreInformation)
);
